import { setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

export const StyledErrorContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    ${setFontVariant("h2")}
`;
